module.exports = __webpack_public_path__ + "static/img/office_03.565af1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/office_03.png
// module id = 6CcZ
// module chunks = 0